'use strict';


export default function() {
	return {
		restrict: 'A',
		require: '^form',
		link: link,
		scope: {},
	};

	function link(scope, element, attrs, $form) {
		element.attr('type', 'submit');
		scope.$form = $form;
		scope.$watch('$form.$invalid || !!$form.$rest.$submitting', function disable(value) {
			attrs.$set('disabled', value);
		});
	}
}
